import {Component} from "../../../gvf/js/component";
import {ObjectService} from "../../js/object-service";
import {GvfService} from "../../../gvf/js/gvf-service";

export class SelectObjectButton extends Component{
    constructor(scope,$root){
        super(scope,$root);
    }

    ready(){
        super.ready();
        this.$root.click(
            (ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                const $button = $(ev.currentTarget);
                this.$root.addClass("is-loading");
                const service = new ObjectService($button.data("model"));
                service.selectModelItem({
                    fieldData:$button.data("data")
                }).then(
                    (id)=>{
                        GvfService.endpoint(
                            $button.data("select-endpoint"),
                            {id:id,fieldData:$button.data("data")}
                        ).then(
                            (resp)=>{
                                if(resp.message){
                                    this.alertEndpointResponse(resp);
                                }

                                if(resp.url){
                                    window.location = resp.url;
                                }else{
                                    this.$root.trigger("selectObjectButton:confirmed");
                                }
                            }
                        ).catch(this.alertEndpointResponse).finally(
                            ()=>{
                                this.$root.removeClass("is-loading");
                            }
                        );
                    }
                );
            }
        );
    }
}

